import ImageData from './Image';

/* eslint-disable camelcase */
class BlogPostData {
  /**
   * @param {{
   *   id: string,
   *   attributes: {
   *     title: string,
   *     slug: string,
   *     external_link: string,
   *     author_name: string,
   *     date: string,
   *     cover_image: object,
   *     categories: { data: Array<{ id: number, attributes: { name: string, slug: string } }> },
   *     tags: Array<string>
   *   }
   * }} data
   */
  constructor(data) {
    if (!data?.attributes) {
      return;
    }

    const {
      id,
      attributes: {
        title,
        subtitle,
        body,
        slug,
        external_link,
        author_name,
        date,
        cover_image,
        categories,
        tags
      }
    } = data;

    this.id = id;
    this.title = title;
    this.subtitle = subtitle;
    this.body = body;
    this.slug = slug;
    this.url = external_link;
    this.author = author_name;
    this.date = date;
    this.image = new ImageData(cover_image?.data);
    this.categories = (categories?.data || []).map((cat) => ({
      id: cat.id,
      name: cat.attributes?.name,
      slug: cat.attributes?.slug
    }));
    this.tags = Array.isArray(tags) ? tags : [];
  }
}

export default BlogPostData;
